import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3baf040b&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=3baf040b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf040b",
  null
  
)

export default component.exports